module.exports = __webpack_public_path__ + "static/media/EVIgarten-web_banner.265df2eb.jpg";